import { useAppDispatch, useAppSelector } from 'app/hooks';
import { MOBILE_ORDER_DISPLAY_ONLY_EDITED } from 'features/Store/constants';
import { COLUMN_WIDTH } from 'features/Store/pages/StoreSettingDetailPage';
import {
  selectStoreSettingDetailDisplayType,
  selectStoreSettingDetailExpandAll,
  selectStoreSettingEditedMenuBookIds,
  storeSettingDetailActions,
} from 'features/Store/storeSettingDetailSlice';
import { countChildSubMenuGroupHasEditedMObileOrderDisplayFlg, getIsExpandStatus } from 'features/Store/utils';
import React, { useEffect, useState } from 'react';
import { MINUS_TEXT, PLUS_TEXT } from 'utils';
import { ChildSubMenuGroup, Course, Genre, Menu, MenuBook, SubGenre, SubMenu, SubMenuGroup } from '../../models';

export interface ChildSubMenuGroupRowCollapseProps {
  menuBook: MenuBook;
  course?: Course;
  genre: Genre;
  subgenre: SubGenre;
  menu: Menu;
  subMenuGroup: SubMenuGroup;
  subMenu: SubMenu;
  childSubMenuGroup: ChildSubMenuGroup;
  children?: React.ReactNode;
}

function ChildSubMenuGroupRow({
  menuBook,
  course,
  genre,
  subgenre,
  menu,
  subMenuGroup,
  subMenu,
  childSubMenuGroup,
  children,
}: ChildSubMenuGroupRowCollapseProps) {
  const dispatch = useAppDispatch();
  const isExpand = useAppSelector(selectStoreSettingDetailExpandAll);
  const editedMenuBookIds = useAppSelector(selectStoreSettingEditedMenuBookIds);
  const displayType = useAppSelector(selectStoreSettingDetailDisplayType);

  const [open, setOpen] = useState(getIsExpandStatus(menuBook, editedMenuBookIds, isExpand));

  let pathId = `${menuBook.id}-${genre.id}-${subgenre.id}-${menu.id}-${subMenuGroup.id}-${subMenu.id}-${childSubMenuGroup.id}`;
  if (course) {
    pathId = `${menuBook.id}-${course.id}-${genre.id}-${subgenre.id}-${menu.id}-${subMenuGroup.id}-${subMenu.id}-${childSubMenuGroup.id}`;
  }

  useEffect(() => {
    const btnExpandElem = document.querySelector(
      `#childsubmenugroup-${pathId}-row .dan-btn-expand`
    ) as HTMLButtonElement;
    function handleBtnExpandElemClick(event: MouseEvent) {
      event.stopPropagation();
      setOpen(!open);
      dispatch(storeSettingDetailActions.setExpandAll(undefined));
      btnExpandElem.innerHTML = !open ? MINUS_TEXT : PLUS_TEXT;
      btnExpandElem?.setAttribute('aria-expanded', !open ? 'true' : 'false');
    }

    if (btnExpandElem) {
      btnExpandElem.addEventListener('click', handleBtnExpandElemClick);
    }

    return () => {
      if (btnExpandElem) {
        btnExpandElem.removeEventListener('click', handleBtnExpandElemClick);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, displayType]);

  useEffect(() => {
    if (isExpand !== undefined) {
      setOpen(getIsExpandStatus(menuBook, editedMenuBookIds, isExpand));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpand]);

  const countTotalEditedMobileOrderDisplay = countChildSubMenuGroupHasEditedMObileOrderDisplayFlg(childSubMenuGroup);
  if (displayType === MOBILE_ORDER_DISPLAY_ONLY_EDITED && countTotalEditedMobileOrderDisplay === 0) {
    return null;
  }

  return (
    <>
      <div id={`childsubmenugroup-${pathId}-row`} className="dan-tr content-visibility-auto">
        <div
          className="dan-td"
          style={{
            width: `${COLUMN_WIDTH.slice(0, 12).reduce((sum, width) => sum + width, 0)}%`,
          }}
        ></div>
        <div className="dan-td" style={{ width: `${COLUMN_WIDTH[12]}%` }}>
          <button
            className="dan-btn-expand"
            tabIndex={-1}
            aria-controls={`childsubmenugroup-${pathId}-content`}
            aria-expanded={open}
          >
            {open ? MINUS_TEXT : PLUS_TEXT}
          </button>
          <span>{childSubMenuGroup.name}</span>
        </div>
        <div className="dan-td justify-content-center" style={{ width: `${COLUMN_WIDTH[13]}%` }}>
          {childSubMenuGroup.cd}
        </div>
        <div
          className="dan-td"
          style={{
            width: `${COLUMN_WIDTH.slice(14, 17).reduce((sum, width) => sum + width, 0)}%`,
          }}
        ></div>
      </div>
      <div style={{ contentVisibility: open ? 'auto' : 'hidden' }}>
        <div id={`childsubmenugroup-${pathId}-content`}>{children}</div>
      </div>
    </>
  );
}

export default ChildSubMenuGroupRow;
